// Hindi translations.
const hi = {
  ui: {
    brand: "My World Quest",
    brand_subtitle: "रंग और सीखो",
    nav: {
      home: "होम", countries: "देश", globe: "ग्लोब", continents: "महाद्वीप",
      color: "रंग", puzzles: "पहेली", games: "खेल", quiz: "क्विज़", parents: "माता-पिता",
      math: "जियो गणित",
      "geo-lines": "विश्व रेखाएँ", "maths-academy": "मैथ अकादमी",
      more: "और",
      advanced: "उन्नत चुनौतियाँ",
      ask: "ग्लोब से पूछें ✨",
      campaigns: "मिशन",
      "dream-trip": "सपनों की यात्रा",
      "hub-learn": "खोजें",
      "hub-create": "बनाएँ",
      "hub-play": "खेलें",
      "hub-discover": "साहसिक",
      knowledge: "थीम रोमांच",
      passport: "मेरा पासपोर्ट",
      stickers: "स्टिकर",
      trip: "यात्रा",
      "spelling-bee": "स्पेलिंग बी",
      "mandala": "मंडला स्टूडियो",
      "admin-lessons": "पाठ प्रशासन",
      "admin-questions": "प्रश्न बैंक प्रशासन",
      "learning-plan": "शिक्षण योजना",
      "term-report": "टर्म रिपोर्ट",
      "teacher": "शिक्षक डैशबोर्ड",
      "quest-games": "क्वेस्ट खेल",
      "coloring": "रंग भरना",
      "pixel-art": "पिक्सेल आर्ट",
      "flag-artist": "झंडा कलाकार",
      "printables": "प्रिंट करने योग्य",
      "play-home": "खेल होम",
      "learn-topics": "सीखने के विषय",
    },
    accessibility: { bigText: "बड़ा टेक्स्ट", highContrast: "हाई कॉन्ट्रास्ट" },
    navGroups: { quick: "त्वरित", explore: "खोजें", play: "खेलें और सीखें", collect: "संग्रह", adv: "साहसिक", grownup: "बड़ों के लिए" },
    actions: { back: "वापस", close: "बंद", reset: "रीसेट", save: "सहेजें", retry: "फिर कोशिश", playAgain: "फिर खेलें" },
  },
  microcopy: {
    great: "शाबाश! ⭐",
    correct: "✅ सही!",
    nope: "फिर कोशिश करो!",
    tryAgain: "गलत है। चलते रहो!",
    awesome: "बहुत बढ़िया!",
    welcome: "{{country}} में स्वागत है! चलो {{language}} सीखें।",
    allPlaced: "सब रख दिए! 🎉",
    youDidIt: "तुमने कर दिखाया!",
    perfect: "बिल्कुल सही!",
  },
  home: {
    streak: "धारा: {{n}} दिन",
    streak_plural: "धारा: {{n}} दिन",
    subtitleShort: "बच्चों को इंटरैक्टिव कारनामों के माध्यम से देशों, संस्कृतियों, स्मारकों और महाद्वीपों का पता लगाने में मदद करना।",
    tagline: "स्क्रीन टाइम से डिस्कवरी टाइम तक",
    title1: "दुनिया की खोज करो",
    title2: "एक देश एक बार में",
    subtitle: "मज़ेदार भूगोल साहसिक कारनामे, क्विज़, चुनौतियाँ और पुरस्कार जो बच्चों को देशों, संस्कृतियों, झंडों, स्मारकों और अधिक की खोज करने में मदद करते हैं।",
    playNow: "अभी खेलो →",
    takeQuiz: "क्विज़ खेलो",
    countryOfTheDay: "🌟 आज का देश",
    discover: "{{name}} को खोजो!",
    letsGo: "चलो",
    whatNext: "आज क्या करना है?",
    whatNextSub: "कुछ भी चुनो — सब मज़ेदार है!",
    tiles: {
      learn: "देश सीखो", learnDesc: "30 से ज़्यादा देश झंडों के साथ!",
      globe: "3डी ग्लोब", globeDesc: "घुमाओ और टैप करके खोजो",
      continents: "महाद्वीप", continentsDesc: "सातों महाद्वीप देखो",
      color: "रंगो", colorDesc: "एफिल टावर रंगो!",
      puzzles: "पहेलियाँ", puzzlesDesc: "स्लाइडिंग और नक्शा पहेली",
      games: "खेल खेलो", gamesDesc: "देश और महाद्वीप मिलाओ",
      quiz: "क्विज़ का समय", quizDesc: "आसान और कठिन क्विज़",
      parents: "माता-पिता के लिए", parentsDesc: "बच्चे की प्रगति देखें",
    },
    stats: { stars: "तारे", countries: "देश", badges: "बैज", streak: "धारा" },
  },
  daily: {
    label: "रोज़ का चैलेंज",
    streakLabel: "धारा {{n}}",
    todayDone: "आज पूरा हुआ!",
    threeQuick: "3 जल्दी सवाल",
    descUnlocked: "3 सवाल हल करो 3 ⭐ के लिए + धारा बोनस (+5 ⭐ तक)।",
    descDone: "तुमने {{score}} पाया। कल फिर आना +1 ⭐ बोनस के लिए!",
    start: "शुरू →",
    done: "पूरा",
    finished: "रोज़ का काम पूरा!",
    score: "स्कोर:",
    streakSuffix: "दिन",
    streakSuffix_plural: "दिन",
    bonus: "(+{{n}} बोनस!)",
  },
  learn: {
    title: "देश सीखो 🌍",
    subtitle: "किसी भी देश के कार्ड पर क्लिक करो। स्पीकर दबाकर सुनो!",
    searchPlaceholder: "देश, राजधानी या जगह खोजो…",
    clear: "साफ़",
    filterAll: "सभी",
    hello: "नमस्ते",
    capital: "राजधानी", language: "भाषा",
    learnedBtn: "मैंने सीख लिया! ⭐",
    learnLang: "भाषा सीखो",
    noResults: "कोई देश नहीं मिला। कुछ और खोजो!",
    goalsEyebrow: "आज के सीखने के लक्ष्य",
    goalsHeading: "🎯 पहले इन पर ध्यान दो",
    goalsSubtitle: "{{tier}} साल की उम्र में सीखने की चार सबसे ज़रूरी बातें — पाठ्यक्रम से चुनी गईं।",
    goalsAllTopics: "सभी विषय देखो",
    goalsLearnNow: "अभी सीखो",
    goalsKey: "मुख्य #{{n}}",
    topicTitles: {
      "art-design": "ड्रॉइंग, पेंटिंग और डिज़ाइन",
      "music": "संगीत: ताल, गाना और स्वरलिपि",
      "computing-code": "कोडिंग, एल्गोरिथम और साइबर सुरक्षा",
      "physical-education": "शारीरिक शिक्षा, स्वास्थ्य और फ़िटनेस",
      "world-religions": "विश्व के धर्म और मान्यताएँ",
      "wellbeing-relationships": "स्वास्थ्य, भावनाएँ और दोस्ती",
    },
  },
  continents: {
    title: "महाद्वीप नक्शे 🗺️",
    subtitle: "किसी महाद्वीप पर टैप करके वहाँ के देश जानो!",
    countriesIn: "{{name}} में देश:",
    learnMore: "और देश सीखो →",
  },
  coloring: {
    title: "इमारतें रंगो 🎨",
    subtitle: "{{n}} इमारतें रंगने के लिए। या प्रिंट करने वाली शीट डाउनलोड करो!",
    printOne: "यह प्रिंट करो",
    printAll: "सभी PDF डाउनलोड",
    tools: "औज़ार",
    colors: "रंग",
    fill: "भरो", pencil: "पेंसिल", erase: "मिटाओ",
    undo: "वापस", redo: "फिर करो",
    sub: "खाली जगह के बगल वाली टाइल को टैप करो। {{name}} को फिर से बनाओ!",
  },
  games: {
    title: "देश मिलाओ! 🎮",
    subtitle: "देश के झंडे को उसके महाद्वीप पर खींचो (या टैप करो)।",
    newGame: "🔄 नया खेल",
    dragFlags: "इन झंडों को खींचो 👇",
  },
  quiz: {
    title: "क्विज़ का समय! 🧠",
    subtitle: "स्तर चुनो। तुम कर सकते हो!",
    basic: "आसान क्विज़",
    advanced: "कठिन क्विज़",
    basicDesc: "देश और महाद्वीप के 5 आसान सवाल।",
    advancedDesc: "10 कठिन सवाल। तैयार हो?",
    upTo: "{{n}} ⭐ तक",
    question: "सवाल {{i}} / {{n}}",
    backToMenu: "मेनू पर वापस",
    perfect: "बिल्कुल सही!",
    greatJob: "शाबाश!",
    youGot: "तुमने पाए",
    outOf: "में से",
  },
  parents: {
    title: "प्रगति डैशबोर्ड 👨‍👩‍👧",
    subtitle: "अपने बच्चे की सीखने की यात्रा देखें।",
    parentsOnly: "केवल माता-पिता",
    mathPrompt: "अंदर आने के लिए यह सवाल हल करें।",
    unlock: "खोलें",
    wrong: "हम्म, फिर कोशिश करें!",
    resetProgress: "प्रगति रीसेट",
    resetConfirm: "सारी प्रगति रीसेट करें? यह वापस नहीं होगा।",
    badges: "बैज",
    recentActivity: "हाल की गतिविधि",
    noActivity: "अभी कुछ नहीं। खोजने का समय!",
    notYet: "अभी नहीं",
    certTitle: "खोज का प्रमाणपत्र!",
    certBody: "आपके बच्चे ने {{stars}} तारे और {{countries}} देश सीखे हैं।",
    printCert: "🖨️ प्रमाणपत्र प्रिंट करें",
    statsLabels: {
      stars: "तारे जीते", streak: "दिन की धारा", countries: "देश सीखे",
      quizzes: "क्विज़ पूरे", games: "खेल जीते", coloring: "रंगे पन्ने",
    },
  },
  lang: {
    title: "{{language}} सीखो",
    sub: "{{country}} से! किसी भी वाक्य को सुनने के लिए टैप करो।",
    welcome: "स्वागत",
    finish: "मैं पूरा! ⭐⭐",
    awesome: "बढ़िया अभ्यास!",
    finishSub: "पाठ पूरा करके 2 तारे जीतो।",
    tapToHear: "सुनने के लिए टैप करो",
    speakTitle: "🎙️ शब्द बोलो",
    speakSubtitle: "माइक दबाओ और हर वाक्य ज़ोर से कहो!",
    speakUnsupported: "वॉइस मोड के लिए Chrome, Edge या Safari iOS 14+ चाहिए।",
    listening: "सुन रहा हूँ…",
    tapMic: "माइक टैप करके कहो:",
    wellDone: "बहुत अच्छा!",
    tryItAgain: "फिर से कहने की कोशिश करो",
    youSaid: "तुमने कहा:",
    expected: "अपेक्षित:",
    phrases: {
      Hello: "नमस्ते", "Thank you": "धन्यवाद", Goodbye: "अलविदा",
      Yes: "हाँ", No: "नहीं", One: "एक", Two: "दो", Three: "तीन",
    },
  },
  globe: {
    title: "3डी ग्लोब 🌐",
    subtitle: "दुनिया घुमाओ। चमकती पिन देश हैं। सुनहरी पिन वे हैं जो तुमने सीखे!",
    learnedCounter: "{{n}} / {{total}} सीखे",
    spinTap: "घुमाओ और टैप!",
    spinTapSub: "ग्लोब पर किसी भी चमकती पिन पर क्लिक करो।",
    learnedTag: "⭐ सीखा",
    moreInfo: "और जानकारी →",
    learnLang: "🗣️ भाषा सीखो",
  },
  puzzles: {
    title: "पहेलियाँ 🧩",
    subtitle: "पहेली का प्रकार चुनो और खेलो!",
    sliding: "🖼️ स्लाइडिंग पहेली",
    shape: "🗺️ नक्शा पहेली",
    placed: "{{done}} / {{total}} रखे",
    tapPrompt: "एक झंडा टैप करो, फिर सही जगह टैप करो।",
    tapNext: "अब सही जगह टैप करो →",
    moves: "चालें: {{n}}",
    best: "बेस्ट: {{n}}",
    shuffle: "मिलाओ",
    solvedIn: "🎉 {{n}} चालों में हल किया!",
    newBest: "🏁 नया रिकॉर्ड {{n}} चालों में!",
    record: "तुम्हारा रिकॉर्ड: {{n}} चालें",
  },
  certificate: {
    title: "🎉 ग्लोब ट्रॉटर!",
    body: "वाह! तुमने {{n}} देश सीखे हैं। तुम सच्चे ग्लोब ट्रॉटर हो!",
    print: "🖨️ मेरा प्रमाणपत्र प्रिंट करें",
    keep: "खोजते रहो",
  },
  langSwitcher: {
    label: "भाषा",
    english: "English", french: "Français", hindi: "हिन्दी", arabic: "العربية",
  },
  common: {
    whereToNext: "आगे कहाँ चलें?",
    home: "होम",
    earnMoreStars: "⭐ और सितारे कमाओ",
    earnHowTo: "एक त्वरित गेम खेलो — हर एक से XP मिलती है!",
    pickAge: "उम्र चुनें",
    ages: "उम्र",
    startExploring: "खोज शुरू करें",
    pickAnywhere: "ऊपर से चुनो — या यहाँ क्लिक करो!",
    tapAnyCountry: "किसी देश को टैप करो और उसकी कहानी सुनो!",
    exploreGlobe: "ग्लोब देखो",
    exploreGlobeSub: "पूर्ण-स्क्रीन 3D रोमांच",
  },
  shortcuts: {
    home: "होम",
    continents: "महाद्वीप",
    globe: "ग्लोब",
    ask: "पूछो",
    landmarks: "स्मारक",
    flags: "झंडे",
    pixel: "पिक्सेल",
    puzzles: "पहेलियाँ",
    math: "गणित",
    trip: "यात्रा",
    quiz: "क्विज़",
    quests: "खोज",
    stickers: "स्टिकर",
    miniGames: "मिनी गेम्स",
    geoMath: "भू-गणित",
    quickQuiz: "त्वरित क्विज़",
    myTrophies: "मेरी ट्रॉफियाँ",
    colorCreate: "रंग और बनाओ",
    spinGlobe: "ग्लोब घुमाओ",
    askGlobe: "ग्लोब से पूछो",
    dreamTrip: "ख्वाबों की यात्रा",
    earnStars: "सितारे कमाओ",
    tryAQuest: "एक खोज करो",
    playAgain: "फिर खेलो",
    learnCountry: "देश सीखो",
    colorLandmark: "स्मारक रंगो",
    learnCountries: "देश सीखो",
    advanced: "उन्नत मोड",
    spellCountry: "एक देश लिखो",
    advancedHub: "उन्नत क्षेत्र",
    squishyHop: "स्क्विशी हॉप",
    mathSnap: "मैथ स्नैप",
    language: "भाषा",
    geoLines: "विश्व रेखाएँ",
  },
  coloringExtra: {
    modeLandmarks: "स्मारक",
    modeFlags: "झंडा कलाकार",
    modePixel: "पिक्सेल आर्ट",
    modeMandala: "मंडला",
    diffEasy: "आसान",
    diffMedium: "मध्यम",
    diffExpert: "विशेषज्ञ",
    difficultyLabel: "कठिनाई:",
  },
  tilesExtra: {
    labelLearn: "सीखो",
    labelCreate: "बनाओ",
    labelPlay: "खेलो",
    labelTrophies: "ट्रॉफी",
    whatNextSub: "कुछ भी चुनो — सब मज़ेदार है!",
  },
  pills: {
    orTry: "या आज़माओ ↓",
    
    squishyHop: "स्क्विशी हॉप",
    mathSnap: "मैथ स्नैप",colorLandmark: "स्मारक रंगो",
    solvePuzzle: "पहेली हल करो",
    dreamTrip: "ख्वाबों की यात्रा",
    geoMath: "भू-गणित आज़माओ",
    continentQuests: "महाद्वीप खोज",
    stickerBook: "स्टिकर एल्बम",
    famousPeople: "मशहूर लोग मिलो",
    culturalSpot: "सांस्कृतिक स्पॉट",
    quickQuiz: "त्वरित क्विज़",
    continentMaps: "महाद्वीप नक्शे",
    spellCountry: "एक देश लिखो",
    flagArtist: "झंडा कलाकार",
    pixelArt: "पिक्सेल आर्ट",
    spinGlobe: "ग्लोब घुमाओ",
    askGlobe: "ग्लोब से पूछो",
    myTrophies: "मेरी ट्रॉफियाँ",
    advancedHub: "उन्नत क्षेत्र",
    geoLines: "विश्व रेखाएँ",
  },
  canvas: {
    tools: "उपकरण",
    brushSize: "ब्रश आकार",
    colors: "रंग",
    patterns: "पैटर्न",
    modes: "मोड",
    solid: "ठोस",
    anyColor: "कोई भी रंग",
    recent: "हाल का",
    sticker: "स्टिकर",
    symmetry: "सममिति",
    colorByNumber: "नंबर से रंग",
    reference: "संदर्भ",
    undo: "वापस",
    redo: "फिर से",
    reset: "रीसेट",
    replay: "रिप्ले",
    check: "जांचो",
    save: "सेव",
    fill: "भरें",
    pencil: "पेंसिल",
    stamp: "स्टांप",
    erase: "मिटाएं",
    on: "ON",
    off: "OFF",
    tool: "उपकरण:",
    pattern: "पैटर्न:",
    printOne: "प्रिंट करें",
    downloadAll: "सब डाउनलोड",
    appTitle: "रंग और बनाओ 🎨",
    appSub: "ब्रश, पैटर्न, स्टिकर, नंबर से रंग और भी बहुत कुछ!",
  },
};

export default hi;
